import { IUpdateStatusOrderPayload, OrderModel } from '@boxx/store-core';
import { createAction, props } from '@ngrx/store';

export enum StoreOrdersActionTypes {
  loadOrdersBegin = '[STORE] Load Orders Begin',
  loadOrdersSuccess = '[STORE] Load Orders Success',
  loadOrdersFail = '[STORE] Load Orders Fail',

  loadOrderByIdBegin = '[STORE] Load Order By Id Begin',
  loadOrderByIdSuccess = '[STORE] Load Order By Id Success',
  loadOrderByIdFail = '[STORE] Load Order By Id Fail',

  updateOrderBegin = '[STORE] Update Order Begin',
  updateOrderSuccess = '[STORE] Update Order Success',
  updateOrderFail = '[STORE] Update Order Fail',

  clearOrdersSuccessErrorData = '[STORE] Clear Orders Success/Error Data',
}

export const loadOrdersBeginAction = createAction(
  StoreOrdersActionTypes.loadOrdersBegin
);

export const loadOrdersSuccessAction = createAction(
  StoreOrdersActionTypes.loadOrdersSuccess,
  props<{ payload: OrderModel[] }>()
);

export const loadOrdersFailAction = createAction(
  StoreOrdersActionTypes.loadOrdersFail,
  props<{ errors: any }>()
);

export const loadOrderByIdBeginAction = createAction(
  StoreOrdersActionTypes.loadOrderByIdBegin,
  props<{ id: number }>()
);

export const loadOrderByIdSuccessAction = createAction(
  StoreOrdersActionTypes.loadOrderByIdSuccess,
  props<{ payload: OrderModel }>()
);

export const loadOrderByIdFailAction = createAction(
  StoreOrdersActionTypes.loadOrderByIdFail,
  props<{ errors: any }>()
);

export const updateOrderBeginAction = createAction(
  StoreOrdersActionTypes.updateOrderBegin,
  props<{ payload: IUpdateStatusOrderPayload }>()
);

export const updateOrderSuccessAction = createAction(
  StoreOrdersActionTypes.updateOrderSuccess,
  props<{ payload: OrderModel }>()
);

export const updateOrderFailAction = createAction(
  StoreOrdersActionTypes.updateOrderFail,
  props<{ errors: any }>()
);

export const clearOrdersSuccessErrorDataAction = createAction(
  StoreOrdersActionTypes.clearOrdersSuccessErrorData
);
